export default __webpack_public_path__ + "static/media/_IMG7362.d6d206d6.jpg";